import styled from "@emotion/styled";

export const AccountWrapper = styled.div`
	display: flex;
	position: relative;
	min-height: 100vh;
`;
